import { SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { lastValueFrom } from 'rxjs';
import { TenantDomainService } from '../services/tenant-domain.service';

export const socialFactory = async (tenant: TenantDomainService): Promise<SocialAuthServiceConfig> => {
  return lastValueFrom(tenant.getSocialProviders());
};
